export default function reducer(state = {}) {
    return state;
};


// WEBPACK FOOTER //
// ./App/redux/reducer.jsx